<template>
  <div class="modal_overlay">
    <div class="modal_content-container" style="width: auto;">
      <img :src="skin.imagen.mascot" alt="" class="mascot2" v-if="skin.skin_type === 'ganamos' && skin.imagen.mascot">
      <div class="age-verification-desktop" :style="skin.header_desktop?.nav_bar">
        <h2 class="age-verification-desktop_title" :style="skin.my_account?.close_btn">{{ translate("veri") }}</h2>
        <span class="age-verification-desktop_sub-title" :style="skin.my_account?.close_btn">
          {{ translate("pregunta") }} 
          <span :style="skin.prematch_event?.teams_text">18+</span>
          {{ translate("pregunta1") }}
        </span>
        <br>
        <div class="age-verification-desktop_button-group">
          <div class="age-verification-desktop_button-container">
            <button type="button" class="button-desktop button-desktop_color_purple p-2" :style="skin.header_desktop?.selection ? skin.header_desktop?.selection + skin.header_desktop?.nav_bar_text : skin.my_account?.main_menu_background" @click="handleYes">
              {{ translate("Yes") }}
            </button>
          </div>
          <div class="age-verification-desktop_button-container">
            <button type="button" class="button-desktop button-desktop_color_purple-bordered" :style="skin.header_desktop?.login_btn" @click="handleNo">
              {{ translate("No") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['language', 'translation'],
  methods: {
    translate(text) {
      if (text) {
        if (this.$props.translation[text]) {
          return this.$props.translation[text][this.$props.language];
        }
        else {
          var new_text_serched = text.replace(/ /g, "_");
          if (this.$props.translation[new_text_serched]) {
            return this.$props.translation[new_text_serched][this.$props.language];
          }
        }
        return text;
      }
    },
    handleYes() {
      this.$emit('age-verified', true);
    },
    handleNo() {
      window.top.location.href = 'https://www.google.com';
    }
  },
  computed:{
    skin(){
      return this.$store.getters['getCurrentSkin'];
    },
  },
};
</script>

<style scoped>
.mascot2{
  position: absolute;
    top: -14rem;
    left: 50%;
    width: 16rem;
    height: 16rem;
    z-index: -1;
    translate: calc(-50% - .3125rem);
 }
.modal_overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal_content-container {
  display: flex;
  width: 111px;
  justify-content: center;
  align-items: center;
  z-index: 1;
  position: absolute;
  left: 50%;
  top: 50%;
  max-height: 134px;
  max-width: 99%;
  transform: translate(-50%, -50%);
  padding: 20px !important;
  border-radius: 15px;
  text-align: center;
  width: 80%;
  /* Usa un porcentaje para hacerlo responsive */
  /* Establece un ancho máximo para pantallas grandes */
  box-sizing: border-box;
  /* Incluye el padding en el tamaño total */
}
.age-verification-desktop {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  gap: 18.75px;
  padding: 30px !important;
  width: 24.75rem;
  min-height: 134.89px;
  border-radius: 11.25px;
}

.age-verification-desktop_title {
  font-size: 1.625rem;
  font-weight: 700;
  text-align: center;
  font-family: 'Roboto', Arial, sans-serif;
}

.age-verification-desktop_sub-title {
  font-size: 1.25rem;
  font-weight: 700;
  text-align: center;
  font-family: 'Roboto', Arial, sans-serif;
}

button {
    font-family: "Sofia Pro", Arial, sans-serif;
}

.age-verification-desktop_button-group {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 6.25px;
  height: 100%;
  min-height: 25px;
}

.age-verification-desktop_button-container {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
}

.button-desktop_color_purple {
  text-transform: none;
  border-radius: 31.25px;
}

.button-desktop {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding: 0 1.719rem;
  border: none;
  user-select: none;
  font-size: .875rem;
  text-align: center;
  outline: none;
  border-radius: 6.25rem;
  white-space: nowrap;
  text-transform: uppercase;
  font-weight: 700;
}

.button-desktop_color_purple-bordered {
  background: rgba(0, 0, 0, 0);
  text-transform: none;
  border-radius: 31.25rem;
}
</style>
